import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { SelectionAdapter } from 'components/SelectPropertiesDrawerV2';

/**
 * Wires SelectPropertiesDrawerV2 to the Loads filter Formik form.
 *
 * Mirrors the field mapping V1 SelectPropertiesDrawer uses by default
 * (cropZones = IDs, sources = full objects, totalArea, sourceType) so the
 * surrounding filter UI (count read from values.cropZones, onReset clearing
 * all four fields) keeps working unchanged.
 *
 * Must be called inside a Formik context.
 */
const useLoadsFilterSelectionAdapter = (): SelectionAdapter => {
  const { values, setFieldValue } = useFormikContext<any>();

  return useMemo(
    () => ({
      initialCropZones: values?.cropZones || [],
      existingCropZones: [],
      onConfirm: ({ cropZoneIds, totalArea, cropZones }) => {
        setFieldValue('cropZones', cropZoneIds);
        setFieldValue('totalArea', totalArea);
        setFieldValue('sources', cropZones);
        setFieldValue('sourceType', 'CROP_ZONE');
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [values?.cropZones]
  );
};

export default useLoadsFilterSelectionAdapter;
